import { useQuery } from '@tanstack/react-query';

import type { IncidentType } from '@/types';

import { API_ROUTES } from '@/query/routes';
import axiosInstance from '@/utils/api/axios-instance';
import processIncidentApiData from '@/utils/helpers/process-incident-api-data';

const getIncidentsByStop = async (stopId: string) => {
  const { data } = await axiosInstance.get<IncidentType[]>(API_ROUTES.incidentsByStopId(stopId));

  return processIncidentApiData(data);
};

export const useGetIncidentsByStop = (stopId?: string | null) => {
  return useQuery<IncidentType[]>({
    queryKey: ['incidents', 'stop', stopId],
    queryFn: () => getIncidentsByStop(stopId!),
    enabled: !!stopId,
    staleTime: 60 * 60 * 1000,
  });
};
